<div [ngClass]="divClass">
    <ng-template #helpTemplate>
        <div>
            <span>{{vm.helpText || vm.title}}</span>
        </div>
        <div *ngIf="validationErrors.length">
            <p class="text-danger" *ngFor="let ve of validationErrors">{{ve}}</p>
        </div>
    </ng-template>

    <label *ngIf="vm.title" [ngStyle]="{ cursor: vm.title && !vm.hideLabel ? 'pointer' : 'inherited'}" class="pb-1" 
        [mdbTooltip]="helpTemplate" [triggers]="vm.title && !vm.hideLabel ? 'hover' : ''">{{vm.title}}
        <mdb-icon *ngIf="validationErrors.length" class="text-danger" fas icon="exclamation-circle"></mdb-icon>
        <mdb-icon *ngIf="vm.isLocked" style="color: #e0e0e0;" fas icon="lock"></mdb-icon>
        <mdb-icon *ngIf="vm.helpText" fas icon="question-circle" class="icon-help"></mdb-icon>
    </label>
    <mdb-select [ngModel]="optionValue" (ngModelChange)="modelChanged($event)" [disabled]="vm.isLocked" 
        #select_ref="ngModel" [required]="vm.isRequired" [options]="vm.options" [placeholder]="vm.placeholder">
    </mdb-select>

</div>
